import cx from 'classnames';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {DiamondIcon} from '~library/svg/DiamondIcon';

import './AdPanel.sass';

export const AdPanel = ({
  showRemoveButton,
  connectCTA,
  bannerImage,
  showHeader = true,
  fullWidth = false,
  classNames = '',
  imageHref = '',
}) => (
  <div
    data-qa-id="fabric-free-banner"
    className={cx(classNames, {
      'fabric-free-banner__wrapper': true,
      'fabric-free-banner__wrapper_full-width': fullWidth,
    })}
  >
    {showHeader && (
      <Typography variant="label3" className="fabric-free-banner__text">
        Advertisement
      </Typography>
    )}
    <div className="fabric-free-banner">
      {imageHref ? (
        <a href={imageHref} target="_blank" rel="noreferrer">
          <img src={bannerImage} alt="invitation-banner" />
        </a>
      ) : (
        <img src={bannerImage} alt="invitation-banner" />
      )}

      {showRemoveButton && (
        <div className="view-invitation__preview-cta multi">
          <Button
            variant="link"
            className="view-invitation__preview-cta"
            data-qa-id="remove-banners"
            id="remove-banner"
            onClick={(elem) => connectCTA && connectCTA('remove-ads', elem)}
            icon={<DiamondIcon className="remove_button__premium-diamond" ratio={1.143} />}
          >
            Remove Ad
          </Button>
        </div>
      )}
    </div>
  </div>
);
